module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/regenerator/index.js
// module id = 248
// module chunks = 1